<template>
  <config-pro-plus-base
    class="opc-zone-bundle__main-add"
    :show-full-comparison-dialog="showFullComparisonDialog"
    show-plan-details>
    <template #config>
      <div class="opc-zone-bundle__main-add-title">
        <p class="label-title-1">
          {{ $t('billing.zone_pro_plus.select_local_number_title') }}
          <zm-tooltip
            slot="label-suffix"
            :content="$t('billing.zone.attendee_info')"
            aria-label="Learn more about numbers"
            placement="top"
          >
            <zm-button ghost icon="zm-icon-info-outline main-color-icon" size="mini" type="icon"></zm-button>
          </zm-tooltip>
        </p>
        <p class="label-desc-1">
          <span>{{ $t('billing.zone_pro_plus.select_local_number_desc') }}</span>
          <zm-button style="margin-left: 4px;" type="link" @click="handleExploreOtherPlans">
            {{ $t('billing.zone_pro_plus.explore_other_plans_cta') }}
          </zm-button>
        </p>
      </div>
      <template>
        <add-config v-if="boughtPbxBasePlan" />
        <config-plan v-else />
      </template>
    </template>
  </config-pro-plus-base>
</template>

<script type="text/jsx">
import ConfigProPlusBase from '@/plans/ZONE_PRO_PLUS/component/config-base';
import AddConfig from '@/plans/ZONE_PRO_PLUS/config/add-config';
import ConfigMixin from '@/plans/ZONE_PRO_PLUS/mixin/config-mixin';
import { mapGetters } from 'vuex';
import ConfigPlan from '@/plans/ZONE_PRO_PLUS/config/config-plan';

export default {
  components: { ConfigPlan, ConfigProPlusBase, AddConfig },
  mixins: [ConfigMixin],
  computed: {
    ...mapGetters(['boughtPbxBasePlan']),
  },
  mounted() {
    this.pbx2PropCheck();
  },
  methods: {
    pbx2PropCheck() {
      if (!this.$isEnabled('enablePbx2Prop')) return Promise.resolve();
      return this.$confirm(
        this.$t('billing.pbx_to_props_desc'),
        this.$t('billing.select_an_upgrade_option'),
        {
          customClass: 'revert-btn__zm-message-box',
          dangerouslyUseHTMLString: true,
          cancelButtonText: this.$t('billing.add_a_new_plan'),
          confirmButtonText: this.$t('billing.bundle_plans'),
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false
        }
      ).then(() => {
        location.replace('/opc/buy/config?plan=zoneproplus&from=zoneproplus_zonepropzvu&type=pbx2prop')
      });
    },
    handleExploreOtherPlans() {
      this.$tracking.buyInteraction('explore other plans', 'zoom workplace pro plus - explore other plans');
      return this.showFullComparisonDialog();
    },
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-zone-bundle__main-add {
    &-title {
      margin-bottom: 8px;

      .label-title-1 {
        font-size: 18px;
        font-weight: 700;
        line-height: 27px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 8px;
      }

      .label-desc-1 {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-align: left;
      }
    }

    .main-color-icon {
      font-size: 14px;
      color: $theme-color;
    }
}
.revert-btn__zm-message-box {
  .zm-message-box__btns {
    display: flex;
    flex-direction: row-reverse;
    gap: 8px;
  }
}
</style>
